import { Component } from '@angular/core';
import { 
  NavController, 
  NavParams
} from 'ionic-angular';

// Providers
import { RecertificationService } from '../../providers/instructors/recertification-service';

// Pages
import { RecertificationViewPage } from '../../pages/recertifications/recertification-view'; 

@Component({
  selector: 'page-recertifications',
  templateUrl: 'recertifications.html'
})

export class RecertificationsPage {
  headerData: any;
  recertifications: any = [];
  recertificationsCopy: any = [];
  searchResults: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public recertificationService: RecertificationService
  ) {
    this.headerData = { title: 'Recertification Applications' };
  }

  getRecertificationApplications()
  {
    this.recertificationService.getRecertifications()
      .subscribe( data => {
        this.recertifications = data;
        for ( let item in this.recertifications )
        {
          this.recertificationsCopy.push( this.recertifications[item] );
        }
      });
  }

  showRecertificationViewPage( recertification )
  {
    this.navCtrl.push( RecertificationViewPage, {
      recertification: recertification
    });
  }

  searchRecertifications( ev )
  {
    let search_term = ev.target.value;

    if ( search_term && search_term.length > 2 )
    {
      // Clear this.recertifications array to prep for search results.
      this.recertifications.length = 0;

      this.recertificationService.searchRecertifications(search_term).subscribe(data => {
        this.searchResults = true;
        this.recertifications = data;

        if ( this.recertifications.length === 0 )
        {
          this.searchResults = false;
        }
      });
    } else {
      // Restore original provider list.
      this.recertifications.length = 0;

      for ( var item in this.recertificationsCopy )
      {
        this.recertifications.push( this.recertificationsCopy[item] );
      }
      this.searchResults = false;
    }
  }

  clearSearch( ev )
  {

  }

  ionViewDidEnter()
  {
    this.getRecertificationApplications();
  }
}


// WEBPACK FOOTER //
// ./src/pages/recertifications/recertifications.ts